"use client"

import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"
import { type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../../utils"
import { toggleVariants } from "../shadcn/toggle"

const ToggleGroupContext = React.createContext<VariantProps<typeof toggleVariants>>({
	color: "default",
	size: "small"
})

function ToggleGroup({ className, color, size, children, ...props }: React.ComponentProps<typeof ToggleGroupPrimitive.Root> & VariantProps<typeof toggleVariants>) {
	return (
		<ToggleGroupPrimitive.Root data-slot="toggle-group" data-size={size} className={cn("group/toggle-group flex gap-2 w-fit items-center", className)} {...props}>
			<ToggleGroupContext.Provider value={{ color, size }}>{children}</ToggleGroupContext.Provider>
		</ToggleGroupPrimitive.Root>
	)
}

function ToggleGroupItem({ className, children, color, size, ...props }: React.ComponentProps<typeof ToggleGroupPrimitive.Item> & VariantProps<typeof toggleVariants>) {
	const context = React.useContext(ToggleGroupContext)

	return (
		<ToggleGroupPrimitive.Item
			data-slot="toggle-group-item"
			data-size={context.size || size}
			data-color={context.color || color}
			className={cn(
				toggleVariants({
					size: context.size || size,
					color: context.color || color
				}),
				className
			)}
			{...props}
		>
			{children}
		</ToggleGroupPrimitive.Item>
	)
}

export { ToggleGroup, ToggleGroupItem }
